// extracted by mini-css-extract-plugin
module.exports =  {"root":"G8ONMNWUdA1xfxRATyKW"};